import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import eachYearOfInterval from 'date-fns/eachYearOfInterval'

export const ensureLastYears = () => {
  const yearDates = eachYearOfInterval({
    start: new Date(1960, 0, 1),
    end: new Date()
  })

  const years = yearDates.map(year => format(year, 'yyyy',{ locale: ptBR })).reverse()

  return years
}
